type Props = {
    className?: string;
};
const BuyerProtectionSVG = ({ className }: Props) => {
    const strokeWidth = '1.5';
    const style = { stroke: 'var(--w-s-color-icon-primary)' };

    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M4.50006 6.53989H4.50007L4.50004 6.53487C4.49781 6.20186 4.59184 5.87528 4.77082 5.59444C4.94871 5.31532 5.20298 5.09318 5.50337 4.95438C10.0717 2.96152 15.0092 1.95529 19.9931 2.00152L19.9931 2.00165L20.007 2.00152C24.9909 1.95529 29.9284 2.96151 34.4967 4.95437C34.7971 5.09317 35.0514 5.31531 35.2293 5.59444C35.4083 5.87528 35.5023 6.20185 35.5001 6.53488L35.5001 6.53487V6.53989V19.2299C35.5 23.0894 34.3305 26.8582 32.1455 30.0397C29.9607 33.2211 26.8631 35.6658 23.261 37.0515C23.261 37.0515 23.2609 37.0515 23.2608 37.0516L21.526 37.7181L21.5258 37.7182C20.5437 38.096 19.4564 38.096 18.4743 37.7182L18.4741 37.7181L16.7393 37.0516C16.7392 37.0515 16.7392 37.0515 16.7391 37.0515C13.137 35.6658 10.0394 33.2211 7.85456 30.0397C5.66965 26.8582 4.50009 23.0894 4.50006 19.2299V6.53989Z"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.1562 25.625C23.1725 25.625 22.375 24.8275 22.375 23.8438C22.375 22.86 23.1725 22.0625 24.1562 22.0625C25.14 22.0625 25.9375 22.86 25.9375 23.8438C25.9375 24.8275 25.14 25.625 24.1562 25.625Z"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.8438 25.625C14.86 25.625 14.0625 24.8275 14.0625 23.8438C14.0625 22.86 14.86 22.0625 15.8438 22.0625C16.8275 22.0625 17.625 22.86 17.625 23.8438C17.625 24.8275 16.8275 25.625 15.8438 25.625Z"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.375 23.25H17.625"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.0625 23.25H12.2812"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.375 23.25V13.375C22.375 12.2704 21.4796 11.375 20.375 11.375H12.2812"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
            />
            <path
                d="M18.8125 14.9375H11.6875"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
            />
            <path
                d="M18.8125 18.5H15.2502"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
            />
            <path
                d="M26.086 23.0025H27.8125C28.0886 23.0025 28.3125 22.7786 28.3125 22.5025V19.6166C28.3125 19.419 28.1961 19.24 28.0156 19.1597L26.5312 18.5L25.4577 15.2794C25.3897 15.0752 25.1986 14.9375 24.9834 14.9375H22.375"
                style={style}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default BuyerProtectionSVG;
